<template>
  <v-container fluid grid-list-md py1 class="parametros">
    <form onSubmit="return false;" @submit="submit" @keyup.ctrl.83="executeValidators">
      <v-layout row wrap class="pb-4">
        <v-flex sm4 md3 lg2 text-center>
          <circle-slider
            v-model="parametros.numeroIntentos"
            circle-color="#cecece"
            progress-color="#337ab7"
            knob-color="#337ab7"
            :min="3"
            :max="1000"
            :step-size="1"
            :disabled="view.action.submit.busy" />
          <div>{{ parametros.numeroIntentos }}</div>
          <label for="numeroIntentos">{{ $t("view.generales.parametros.form.numeroIntentos.label") }}</label>
        </v-flex>
        <v-flex sm4 md3 lg2 text-center>
          <circle-slider
            v-model="parametros.maxFileSize"
            circle-color="#cecece"
            progress-color="#337ab7"
            knob-color="#337ab7"
            :min="1"
            :max="1000"
            :step-size="1"
            :disabled="view.action.submit.busy" />
          <div>{{ parametros.maxFileSize }} MB</div>
          <label for="maxFileSize">{{ $t("view.generales.parametros.form.maxFileSize.label") }}</label>
        </v-flex>
        <v-flex sm4 md3 lg2 text-center>
          <circle-slider
            v-model="parametros.maxFileSizeZip"
            circle-color="#cecece"
            progress-color="#337ab7"
            knob-color="#337ab7"
            :min="1"
            :max="25"
            :step-size="1"
            :disabled="view.action.submit.busy" />
          <div>{{ parametros.maxFileSizeZip }} MB</div>
          <label for="maxFileSizeZip">{{ $t("view.generales.parametros.form.maxFileSizeZip.label") }}</label>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md6>
          <v-card>
            <v-toolbar dense dark color="secondary">
              <v-toolbar-title>{{ $t("view.generales.parametros.form.buzonu.label") }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-flex>
                <v-switch v-model="parametros.enableSFTPU" input-value="true" color="primary" :label="$t('view.generales.parametros.form.enableSFTPU.label')" />
              </v-flex>

              <v-flex>
                <v-text-field
                  v-model="$v.parametros.urlBuzonSFTPU.$model"
                  :placeholder="$t('view.commons.url')"
                  :disabled="!parametros.enableSFTPU"
                  prefix="sftp://"
                  :error-messages="getFirstErrorDescription($v.parametros.urlBuzonSFTPU)"
                  :label="$t('view.commons.url')" />
              </v-flex>

              <v-flex>
                <v-text-field
                  v-model="$v.parametros.puertoBuzonSFTPU.$model"
                  type="number"
                  :disabled="!parametros.enableSFTPU"
                  :error-messages="getFirstErrorDescription($v.parametros.puertoBuzonSFTPU)"
                  :label="$t('view.commons.puerto')"
                  maxlength="10"
                  onkeypress="return /^[0-9]*$/.test(event.key);" />
              </v-flex>

              <v-flex>
                <v-text-field
                  v-model="$v.parametros.usuarioBuzonSFTPU.$model"
                  :disabled="!parametros.enableSFTPU"
                  :error-messages="getFirstErrorDescription($v.parametros.usuarioBuzonSFTPU)"
                  :label="$t('view.commons.usuario')" />
              </v-flex>

              <v-flex>
                <v-text-field
                  v-model="$v.parametros.passwordBuzonSFTPU.$model"
                  :disabled="!parametros.enableSFTPU"
                  type="password"
                  :error-messages="getFirstErrorDescription($v.parametros.passwordBuzonSFTPU)"
                  :label="$t('view.commons.contrasena')" />
              </v-flex>

              <v-flex>
                <v-text-field
                  v-model="$v.parametros.directorioSFTPU.$model"
                  :disabled="!parametros.enableSFTPU"
                  :error-messages="getFirstErrorDescription($v.parametros.directorioSFTPU)"
                  :label="$t('view.commons.directorio')" />
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex md6>
          <v-card>
            <v-toolbar dense dark color="secondary">
              <v-toolbar-title>{{ $t("view.generales.parametros.form.buzond.label") }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-flex>
                <v-switch v-model="parametros.enableSFTPD" input-value="true" color="primary" :label="$t('view.generales.parametros.form.enableSFTPD.label')" />
              </v-flex>

              <v-flex>
                <v-text-field
                  v-model="$v.parametros.urlBuzonSFTPD.$model"
                  :placeholder="$t('view.commons.url')"
                  :disabled="!parametros.enableSFTPD"
                  prefix="sftp://"
                  :error-messages="getFirstErrorDescription($v.parametros.urlBuzonSFTPD)"
                  :label="$t('view.commons.url')" />
              </v-flex>

              <v-flex>
                <v-text-field
                  v-model="$v.parametros.puertoBuzonSFTPD.$model"
                  type="number"
                  :disabled="!parametros.enableSFTPD"
                  :error-messages="getFirstErrorDescription($v.parametros.puertoBuzonSFTPD)"
                  :label="$t('view.commons.puerto')"
                  maxlength="10"
                  onkeypress="return /^[0-9]*$/.test(event.key);" />
              </v-flex>

              <v-flex>
                <v-text-field
                  v-model="$v.parametros.usuarioBuzonSFTPD.$model"
                  :disabled="!parametros.enableSFTPD"
                  :error-messages="getFirstErrorDescription($v.parametros.usuarioBuzonSFTPD)"
                  :label="$t('view.commons.usuario')" />
              </v-flex>

              <v-flex>
                <v-text-field
                  v-model="$v.parametros.passwordBuzonSFTPD.$model"
                  :disabled="!parametros.enableSFTPD"
                  type="password"
                  :error-messages="getFirstErrorDescription($v.parametros.passwordBuzonSFTPD)"
                  :label="$t('view.commons.contrasena')" />
              </v-flex>

              <v-flex>
                <v-text-field
                  v-model="$v.parametros.directorioSFTPD.$model"
                  :disabled="!parametros.enableSFTPD"
                  :error-messages="getFirstErrorDescription($v.parametros.directorioSFTPD)"
                  :label="$t('view.commons.directorio')" />
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex md6>
          <v-card>
            <v-toolbar dense dark color="secondary">
              <v-toolbar-title>{{ $t("view.generales.parametros.form.encriptacion.label") }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row>
                <v-flex md6>
                  <v-switch v-model="parametros.enableZIP" input-value="true" color="primary" :label="$t('view.generales.parametros.form.enableZIP.label')" />
                </v-flex>

                <v-flex md6>
                  <v-text-field
                    v-model="parametros.passwordZIP"
                    :disabled="!parametros.enableZIP"
                    type="password"
                    :error-messages="getFirstErrorDescription($v.parametros.passwordZIP)"
                    :label="$t('view.generales.parametros.form.passwordZIP.label')" />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex md6>
          <v-card>
            <v-toolbar dense dark color="secondary">
              <v-toolbar-title>{{ $t("view.generales.parametros.form.mail.label") }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row>
                <v-flex md6>
                  <v-switch v-model="parametros.enableMail" input-value="true" color="primary" :label="$t('view.generales.parametros.form.enableMail.label')" />
                </v-flex>
                <v-flex md6>
                  <v-switch v-model="parametros.enableMailBases" input-value="true" color="primary" :label="$t('view.generales.parametros.form.enableMailBases.label')" />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex md6>
          <v-card>
            <v-toolbar dense dark color="secondary">
              <v-toolbar-title>{{ $t("view.generales.parametros.form.geolocalizacion.label") }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row>
                <v-flex md12>
                  <v-switch v-model="parametros.geocodeMapbox" input-value="true" color="primary" :label="$t('view.generales.parametros.form.geocodeMapbox.label')" />
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex md2>
                  <v-text-field
                    ref="geoPais"
                    v-model.trim="$v.parametros.geoPais.$model"
                    :label="$t('view.generales.parametros.form.geoPais.label')"
                    :error-messages="getFirstErrorDescription($v.parametros.geoPais)"
                    maxlength="50" />
                </v-flex>
                <v-flex md10>
                  <v-text-field
                    ref="geoPaisCompleto"
                    v-model.trim="$v.parametros.geoPaisCompleto.$model"
                    :label="$t('view.generales.parametros.form.geoPaisCompleto.label')"
                    :error-messages="getFirstErrorDescription($v.parametros.geoPaisCompleto)"
                    maxlength="50" />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-subtitle>{{ $t("view.generales.parametros.form.valoresMinimos.label") }}</v-card-subtitle>
            <v-card-text>
              <v-layout row>
                <v-flex md4>
                  <v-text-field
                    v-model.number="$v.parametros.geoRelevanciaBuena.$model"
                    :label="$t('view.generales.parametros.form.geoRelevanciaBuena.label')"
                    :error-messages="getFirstErrorDescription($v.parametros.geoRelevanciaBuena)"
                    type="number"
                    step="0.01"
                    :rules="rules.geoRelevancia" />
                </v-flex>
                <v-flex md4>
                  <v-text-field
                    v-model.number="$v.parametros.geoRelevanciaRegular.$model"
                    :label="$t('view.generales.parametros.form.geoRelevanciaRegular.label')"
                    :error-messages="getFirstErrorDescription($v.parametros.geoRelevanciaRegular)"
                    type="number"
                    step="0.01"
                    :rules="rules.geoRelevancia" />
                </v-flex>
                <v-flex md4>
                  <v-text-field
                    v-model.number="$v.parametros.geoRelevanciaMala.$model"
                    :label="$t('view.generales.parametros.form.geoRelevanciaMala.label')"
                    :error-messages="getFirstErrorDescription($v.parametros.geoRelevanciaMala)"
                    type="number"
                    step="0.01"
                    :rules="rules.geoRelevancia" />
                </v-flex>
              </v-layout>
              <v-divider :thickness="5"></v-divider>
              <v-layout row>
                <v-flex md12>
                  <v-switch v-model="parametros.geocodeGoogle" input-value="true" color="primary" :label="$t('view.generales.parametros.form.geocodeGoogle.label')" />
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex md12>
                  <v-switch v-model="parametros.geocodeGoogleRelMala" input-value="true" color="primary" :label="$t('view.generales.parametros.form.geocodeGoogleRelMala.label')" />
                  <v-switch v-model="parametros.geocodeGoogleRelRegular" input-value="true" color="primary" :label="$t('view.generales.parametros.form.geocodeGoogleRelRegular.label')" />
                  <v-switch v-model="parametros.geocodeGoogleRelBuena" input-value="true" color="primary" :label="$t('view.generales.parametros.form.geocodeGoogleRelBuena.label')" />
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex md12>
                  <v-switch v-model="parametros.geocodeGoogleImportarBases" input-value="true" color="primary" :label="$t('view.generales.parametros.form.geocodeGoogleImportarBases.label')" />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </form>

    <v-layout align-center column class="fab-container">
      <v-btn fab small color="primary" class="btn_tippy" :title="$t('view.commons.download')" :loading="view.action.submit.busy" @click="downloadMigration()">
        <v-icon small>button__icon icon fas fa-download</v-icon>
      </v-btn>

      <v-btn
        v-show="parametros.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
        id="btnaudit"
        fab
        small
        color="primary"
        class="btn_tippy"
        :title="$t('view.commons.audit')"
        :loading="view.action.submit.busy"
        @click="audit()">
        <v-icon small>storage</v-icon>
      </v-btn>

      <v-btn
        v-show="parametros.clave && $userPermission.hasPermission('ROLE_MODIFICAR_CATALOGOS')"
        id="btnsubmit"
        fab
        small
        color="primary"
        class="btn_tippy"
        :title="$t('view.commons.update')"
        :loading="view.action.submit.busy"
        :disabled="form.$state.isDisableButtonSubmit()"
        @click="submit()">
        <v-icon small>button__icon icon fas fa-check</v-icon>
      </v-btn>
    </v-layout>

    <auditoria ref="auditModal" />
  </v-container>
</template>

<script>
import parametrosStates from "@/views/generales/parametros/parametros-state"; /* ************************************* */
import ParametrosAPI from "@/services/generales/parametros"; /* ************************************* */
import MigratorAPI from "@/services/generales/migrator"; /* ************************************* */
import Auditoria from "@/components/auditoria/Auditoria"; /* ************************************* */
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required, requiredIf } from "vuelidate/lib/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import tippy from "tippy.js";

// Action's state
const action = { submit: { busy: false } };

// Initial Model
export default {
  name: "ParametrosModule"
  , components: { Auditoria }
  , data() {
    let _locale = this.$store.language;
    return {
      locale: _locale
      , parametros: undefined
      , view: {
        title: this.$t("view.generales.parametros.title")
        , action
      }
      , check: true
      , form: new Object()
      , rules: { geoRelevancia: [(v) => !!v || this.$t("view.generales.parametros.rules.requerido.text"), (v) => (v >= 0 && v <= 1) || this.$t("view.generales.parametros.rules.geoRelevancia.text")] }
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , async created() {
    this.form = new parametrosStates(this);
    this.form.$setState("initial");
    this.loadParametros();
  }
  , mounted() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.parametros);
        console.log(respuesta);
        if (handleResponse(respuesta, this.$t("view.generales.parametros.errors"))) {
          this.parametros.clave = 1;
          this.form.$setState("editing", respuesta.data.results.parametros);
        }
      } catch (error) {
        handleResponse(error, this.$t("view.generales.parametros.errors"));
        console.log(error);
      }
    }
    , async audit(clave = this.parametros.clave, dataDescripcion = this.$t("view.menu.catalogosGenerales.sub.parametros.text")) {
      this.$refs.auditModal.loadAudit(clave, "TParametros", dataDescripcion, this.view.title);
    }
    , async loadParametros(idParametros = this.parametros.clave) {
      try {
        const response = await ParametrosAPI.get({ clave: idParametros });
        const { data: { results: { parametros } } } = response;
        this.form.$setState("editing", parametros);
      } catch (error) {
        console.log(error);
      }
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
      }
    }
    , async downloadMigration() {
      try {
        this.view.action.submit.busy = true;
        const response = await MigratorAPI.download();
        const url = globalThis.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", response.headers.filename); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.log(error);
      }
      this.view.action.submit.busy = false;
    }
  }
  , validations: {
    parametros: {
      urlBuzonSFTPU: {
        required: requiredIf(function () {
          return this.parametros.enableSFTPU;
        })
      }
      , usuarioBuzonSFTPU: {
        required: requiredIf(function () {
          return this.parametros.enableSFTPU;
        })
      }
      , passwordBuzonSFTPU: {
        required: requiredIf(function () {
          return this.parametros.enableSFTPU;
        })
      }
      , puertoBuzonSFTPU: {
        required: requiredIf(function () {
          return this.parametros.enableSFTPU;
        })
      }
      , directorioSFTPU: {
        required: requiredIf(function () {
          return this.parametros.enableSFTPU;
        })
      }
      , urlBuzonSFTPD: {
        required: requiredIf(function () {
          return this.parametros.enableSFTPD;
        })
      }
      , usuarioBuzonSFTPD: {
        required: requiredIf(function () {
          return this.parametros.enableSFTPD;
        })
      }
      , passwordBuzonSFTPD: {
        required: requiredIf(function () {
          return this.parametros.enableSFTPD;
        })
      }
      , puertoBuzonSFTPD: {
        required: requiredIf(function () {
          return this.parametros.enableSFTPD;
        })
      }
      , directorioSFTPD: {
        required: requiredIf(function () {
          return this.parametros.enableSFTPD;
        })
      }
      , passwordZIP: {
        required: requiredIf(function () {
          return this.parametros.enableZIP;
        })
      }
      , geoPais: { required }
      , geoPaisCompleto: { required }
      , geoRelevanciaBuena: { required }
      , geoRelevanciaRegular: { required }
      , geoRelevanciaMala: { required }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.parametros .v-text-field__prefix {
  width: 50px !important;
  text-align: right;
  padding-right: 4px;
}

.parametros .fab-container {
  position: fixed;
  bottom: 90px;
  right: 20px;
  z-index: 1;
}
.parametros .fab-container .v-btn {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/generales/parametros/Parametros.vue